/**
 * User-friendly per-action time defaults for the /how-it-works page
 * and any surface that explains how time saved is calculated.
 *
 * These are the canonical numbers shown to users.
 * The TIME_WEIGHTS in time-saved.ts are the internal calculation weights.
 */
export const PER_ACTION_DEFAULTS = [
  { action: 'Read a low-value newsletter and archive', seconds: 15, why: 'Skim, decide, archive' },
  { action: 'Unsubscribe and delete a promo', seconds: 30, why: 'Open, find unsubscribe, confirm' },
  { action: 'Sort and label a receipt', seconds: 20, why: 'Skim, label, file' },
  { action: 'Decide whether an update needs reply', seconds: 45, why: 'Read, context-switch, decide' },
] as const
